/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { Badge, Grid, Skeleton, styled, Tooltip } from "@mui/material";
import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useMutation, useQueryClient } from "react-query";
import { connect, useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, withRouter } from "react-router-dom";
import { useHtmlClassService } from "../..";
import { WORK_FLOW_TYPE } from "../../../../app/config/cacheKey";
import { noticeSummaryResponse } from "../../../../app/models/SupplierNotice.model";
import { setNoticeSummary } from "../../../../app/redux/summaryCount/summaryCountAction";
import { GetSupplierNoticeSummary } from "../../../../app/services/SupplierNotice.service";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { DropdownTopbarItemToggler } from "../../../_partials/dropdowns/DropdownTopbarItemToggler";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { GetWalletInfoResponse } from "../../../../app/models/supplierPayment.model";
import {
  IgroupedByBranches,
  IgroupedByIban,
  walletInfoResponse,
} from "../../../../app/models/supplier.model";
import { GetWalletInfo } from "../../../../app/services/supplier.service";

function Wallet() {
  const [color, setColor] = useState(false);
  const uiService = useHtmlClassService();
  const [walletInfo, setWalletInfo] = useState<walletInfoResponse>();
  const history = useHistory();
  const queryClient = useQueryClient();
  const jsonFile = useSelector((state: any) => state.style);
  const handleClick = (item: any) => {
    queryClient.setQueryData(WORK_FLOW_TYPE, item.cartableName);

    // history.push({
    //   pathname: `/cartable/${item.cartableName}`,
    //   state: { refetchStatus: true },
    // });
  };
  const { mutate: GetWalletInfoMutate } = useMutation(GetWalletInfo, {
    onSuccess: (data: walletInfoResponse) => {
      if (data) {
        setWalletInfo(data);
      }
    },
  });

  const handelMutateWallet = () => {
    GetWalletInfoMutate();
  };
  const handelOnClick = () => {
    history.push({
      pathname: `/financial/WaitForSettlement`,
    });
  };
  return (
    <Dropdown
      drop="down"
      alignRight
      className="dropdownWallet"
      onToggle={() => {
        setColor(!color);
      }}
    >
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={"borderLeft-TopBarIcon px-2 cartSummary "}
          onClick={handelMutateWallet}
          style={
            color ? { color: `${jsonFile?.secondColor}` } : { color: "#707070" }
          }
        >
          <Tooltip title="کیف پول" arrow>
            <Badge
              color={jsonFile?.badgeColor || "default"}
              sx={{
                "&.MuiBadge-badge": {
                  fontWeight: "bold",
                  fontSize: "14px !important",
                  direction: "ltr",
                },
              }}
              // badgeContent={"+99"}
            >
              <WalletLogo
                fill={color ? `${jsonFile?.secondColor}` : "#707070"}
              />
              {/* <AccountBalanceWalletOutlinedIcon className="Icons  cursorPointer " /> */}
              <b style={{ margin: "0px 6px 0 0" }}> کیف پول</b>
            </Badge>
          </Tooltip>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="p-0 m-0 dropdown-menu-right dropd
      own-menu-anim dropdown-menu-top-unround dropdown-menu-xl divDrop dropMenuWidth"
      >
        <>
          {walletInfo ? (
            <div>
              <div
                className="d-flex colorFFF align-items-center justify-content-between flex-wrap p-6 bgi-size-cover bgi-no-repeat rounded-top"
                // style={{
                //   background: `url(${toAbsoluteUrl("/media/bg/bg-8.jpg")})`,
                // }}
              >
                <Grid container xs={12} spacing={2} className="mTop5">
                  <Grid xs={6}>
                    <AccountBalanceWalletOutlinedIcon className="iconProfile  marginLeft-15 iconProfileBorder" />
                    <span style={{ color: "#fff" }}>موجودی کیف پول</span>
                  </Grid>
                  <Grid xs={6} className="colorFFF textFont14">
                    {/* <b>{"supplierUserFullName"}</b> */}
                    <div
                      className="colorFFF textFont14  mTop5 secondColor_100"
                      style={{ display: "grid", justifyContent: "end" }}
                    >
                      {" "}
                      {walletInfo?.totalWalletAmount.toLocaleString()} ریال
                    </div>
                  </Grid>
                  <Grid />
                  <Grid item xs={12} className="padingLeft-0">
                    <hr
                      style={{
                        color: "#fff",
                        opacity: "25%",
                        border: "1px solid",
                      }}
                    />
                  </Grid>
                  <Grid container xs={12}>
                    <Grid xs={6}>
                      <span>تاریخ آخرین پرداخت وجه:</span>
                    </Grid>
                    <Grid xs={6}>
                      <span style={{ display: "grid", justifyContent: "end" }}>
                        {walletInfo?.lastPaymentDatePersian}
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <Grid
                container
                xs={12}
                style={{ backgroundColor: "#7FD6FF20", minHeight: "54px" }}
              >
                <button
                  onClick={handelOnClick}
                  style={{
                    width: "100%",
                    textAlign: "center",
                    color: "#7FD6FF",
                    alignContent: "center",
                    backgroundColor: "#7FD6FF20",
                    borderRadius: "5px",
                    border: "none",
                  }}
                >
                  مشاهده جزییات
                </button>
              </Grid>
            </div>
          ) : (
            <>
              <Skeleton
                variant="rounded"
                width={"92%"}
                height={"45px"}
                animation="wave"
                sx={{
                  bgcolor: "#cdc4c42b",
                  margin: "15px 15px 10px 5px",
                }}
              />
              <hr
                style={{ borderBottom: "1px solid gray", padding: "0 2px " }}
              />
              <Skeleton
                variant="rounded"
                width={"92%"}
                height={"45px"}
                animation="wave"
                sx={{ bgcolor: "#cdc4c42b", margin: "15px 15px 10px 5px" }}
              />
              <Skeleton
                variant="rounded"
                width={"92%"}
                height={"45px"}
                animation="wave"
                sx={{ bgcolor: "#cdc4c42b", margin: "0px 15px 10px 5px" }}
              />
            </>
          )}
        </>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const TOKEN_KEY = "token";
const handelToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.setItem("setActivePage", "Wellcome");
};
interface CurrentNoticeCmpPropsInterface {
  summatyNotice: any;
}
const mapStateToProps = ({ summatyNotice }: CurrentNoticeCmpPropsInterface) => {
  return { summatyNotice };
};

export default withRouter(connect(mapStateToProps)(Wallet));

function WalletLogo({ fill }: { fill: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
    >
      <g
        id="Group_143467"
        data-name="Group 143467"
        transform="translate(-10 -3)"
      >
        <path
          id="Path_41155"
          data-name="Path 41155"
          d="M21,7.28V5a2.006,2.006,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V16.72A2,2,0,0,0,22,15V9a2,2,0,0,0-1-1.72ZM20,9v6H13V9ZM5,19V5H19V7H13a2.006,2.006,0,0,0-2,2v6a2.006,2.006,0,0,0,2,2h6v2Z"
          transform="translate(7)"
          fill={fill}
        />
        <circle
          id="Ellipse_157"
          data-name="Ellipse 157"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(14.5 10.5)"
          fill={fill}
        />
      </g>
    </svg>
  );
}
